import { memo } from 'react';
import PropTypes from 'prop-types';
import { PorcentajeMatch } from '@/components/PorcentajeMatch';

/**
 * Wrapper memoizado de PorcentajeMatch para usar en celdas de tabla.
 * Evita que React desmonte/remonte el componente en cada render del padre.
 */
export const PorcentajeMatchCell = memo(function PorcentajeMatchCell({ value }) {
    return <PorcentajeMatch value={value} />;
});

PorcentajeMatchCell.propTypes = {
    value: PropTypes.number,
};
